const chartId = "chart-0"
let Chart = require('chart.js');
Chart.defaults.global.defaultFontFamily = 'acumin-pro';
const data = require('./data');
const config = require('../../../config');
const full = config.colorHues.full; //full colors
const eighty = config.colorHues.eighty; //80% colors

let ctx = document.getElementById(chartId).getContext('2d');

let labels = data.reverse().map(x => x.geo)
let dataset = data.map(x=>x.LE);
new Chart(ctx, {
  type: 'bar',
  data: {
    labels: labels,
    datasets: [{
      label: 'Life Expectancy',
      data: dataset,
      backgroundColor: eighty,
      borderColor: full,
      borderWidth: 1,
      fontColor: 'white'
    }]
  },
  options: {
    responsive: true,
    aspectRatio: window.innerWidth > 992 ? 3 : 1,
    onResize: function(chartObj) {
      chartObj.aspectRatio = window.innerWidth > 992 ? 3 : 1;
      chartObj.update()
    },
    legend: {
      display: false
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: false,
          min: 73,
          max: 80,
          fontColor: "white"
        },
        scaleLabel: {
          display: true,
          labelString: 'Life Expectancy',
          fontColor: "white"
        }
      }],
      xAxes: [{
        ticks: {
          fontColor: "white"
        },
      }]
    }
  }
})